/* Mega menu desktop + drawer mobile a due schermate — behaviour estratto da sections/header.liquid.
   Espone HendyMegaMenu e HendyMobileNav, entrambi con init(root)/destroy(root): <store-header>
   delega qui, così tutti i listener del menu vivono in un posto solo e init resta idempotente
   anche se il Theme Editor ricarica la sezione due volte di fila. */
(function () {
  'use strict';

  var MegaMenu = {
    init: function (root) {
      if (!root || root.dataset.megaInit === 'true') return;
      var dropdowns = Array.from(root.querySelectorAll('.header__dropdown'));
      if (!dropdowns.length) return;
      root.dataset.megaInit = 'true';
      var state = { dropdowns: dropdowns };
      root._mega = state;

      // Keep each summary's aria-expanded in sync with the panel's real visible state — native
      // [open] (click / Enter-Space / touch) OR the hover/focus .is-hover-open layer — so assistive
      // tech never reads "collapsed" while the mega panel is actually on screen.
      var syncExpanded = function (dropdown) {
        var summary = dropdown.querySelector('summary');
        if (!summary) return;
        var shown = dropdown.open || dropdown.classList.contains('is-hover-open');
        summary.setAttribute('aria-expanded', shown ? 'true' : 'false');
      };
      state.syncExpanded = syncExpanded;

      var syncScrim = function () { MegaMenu.syncScrim(root); };

      // The native toggle event covers click / keyboard / touch opens and closes.
      dropdowns.forEach(function (dropdown) {
        dropdown.addEventListener('toggle', function () { syncExpanded(dropdown); syncScrim(); });
        syncExpanded(dropdown);
      });

      // Card in evidenza che cambia all'hover: tutte le varianti sono già nel DOM (hidden), così
      // restano image_tag completi con srcset e prezzi renderizzati da Liquid. Senza JS resta
      // visibile la card di default.
      // Sul costo delle immagini: NON è `loading="lazy"` a differirle (lazy differisce solo le
      // immagini lontane dal viewport, e il pannello sta a ~150px dal bordo superiore). Le card
      // sorelle non si scaricano perché `[hidden]` toglie loro il box di layout; la card di
      // DEFAULT, che un box ce l'ha, è differita da `content-visibility: hidden` sul rail a
      // pannello chiuso (component-mega-menu.css) — prima veniva scaricata su ogni pagina.
      dropdowns.forEach(function (dropdown) {
        var feats = dropdown.querySelector('[data-mega-feats]');
        if (!feats) return;
        var cards = Array.from(feats.children);
        var fallback = cards.find(function (c) { return !c.hasAttribute('data-mega-feature-id'); });
        var show = function (id) {
          // Resolve the target BEFORE touching any [hidden]: a half-configured mega_menu_feature
          // block gets a trigger (data-mega-feature="<id>") from the Liquid loop in
          // mega-menu.liquid as soon as match_title/match_link_title resolve, but
          // mega-menu-promo.liquid renders no card at all when none of promo_product/
          // promo_image/promo_title resolve — so `id` can point at nothing in the rail. Without
          // this guard every card (including the fallback) would read isTarget === false and get
          // hidden, blanking the whole rail on hover. If an id was requested but no card carries
          // it, bail out and leave the rail exactly as it was.
          var target = id
            ? cards.find(function (c) { return c.getAttribute('data-mega-feature-id') === id; })
            : fallback;
          if (id && !target) return;
          // Symmetric case (HIGH-1 fix): id is null (initial state / dropdown mouseleave) but
          // there is no fallback card either, because the mega_menu block behind this panel has
          // no default card of its own — only mega_menu_feature siblings, gated into existence by
          // feature_has_content in header.liquid/mega-menu.liquid. Without this guard, `target`
          // resolves to undefined and the forEach below hides every card (including whichever
          // feature card a previous hover had just revealed), blanking the whole rail.
          if (!id && !target) return;
          cards.forEach(function (card) { card.hidden = card !== target; });
        };
        dropdown.querySelectorAll('[data-mega-feature]').forEach(function (trigger) {
          var id = trigger.getAttribute('data-mega-feature');
          trigger.addEventListener('mouseenter', function () { show(id); });
          trigger.addEventListener('focusin', function () { show(id); });
        });
        // No columns-level mouseleave reset here on purpose (see the dropdown-level listener
        // right below): .header__mega-columns (the trigger links) and .header__mega-rail (the
        // swapped card) are flex SIBLINGS, not ancestor/descendant, so leaving the columns box is
        // the natural path a mouse takes on its way from a trigger link to the card it just
        // swapped in. Resetting on that mouseleave reverted the swap before the pointer ever
        // reached the rail. The dropdown-level mouseleave below already covers the behaviour
        // actually wanted — "the pointer left the whole panel" — without that false positive.
        dropdown.addEventListener('mouseleave', function () { show(null); });
      });

      var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      // In modalità "click" il pannello deve aprirsi SOLO col toggle nativo del <details>: i
      // listener che aprono in hover/focus non vanno registrati affatto. Erano invece registrati
      // in ogni caso (openMode gatava solo il click-to-navigate del summary), quindi il setting
      // era inerte — il puntatore apriva il pannello lo stesso. Chiusura con ESC, click esterno e
      // single-open passano dai listener a livello di documento e valgono in entrambe le modalità.
      var openMode = root.classList.contains('header--mega-click') ? 'click' : 'hover';

      // Apertura in hover via classe .is-hover-open (NON [open] nativo: l'apertura nativa fa saltare
      // l'animazione di entrata perché Chromium mostra i contenuti del <details> con un salto di
      // content-visibility). Il full-width e le transizioni sono garantiti dal CSS
      // (.header__dropdown::details-content { content-visibility: visible }). Single-open coerente
      // col click: chiude gli altri, anche quelli aperti col click ([open]).
      var openDropdown = function (dropdown) {
        dropdowns.forEach(function (other) {
          if (other !== dropdown) {
            if (other.open) other.open = false;
            other.classList.remove('is-hover-open');
            syncExpanded(other);
          }
        });
        dropdown.classList.add('is-hover-open');
        syncExpanded(dropdown);
        syncScrim();
      };
      var closeDropdown = function (dropdown) {
        dropdown.classList.remove('is-hover-open');
        syncExpanded(dropdown);
        syncScrim();
      };
      state.openDropdown = openDropdown;

      if (hoverCapable && openMode === 'hover') {
        dropdowns.forEach(function (dropdown) {
          var openTimer;
          var closeTimer;
          dropdown.addEventListener('mouseenter', function () {
            clearTimeout(closeTimer);
            openTimer = setTimeout(function () { openDropdown(dropdown); }, 60);
          });
          dropdown.addEventListener('mouseleave', function () {
            clearTimeout(openTimer);
            closeTimer = setTimeout(function () { closeDropdown(dropdown); }, 250);
          });
          dropdown.addEventListener('focusin', function () {
            // Suppressed for one frame right after Escape returns focus to the summary (see
            // onDocKeydown below) — that focus() call fires this same listener synchronously
            // and would otherwise reopen the panel it was just told to close.
            if (state.suppressFocusReopen) return;
            openDropdown(dropdown);
          });
          dropdown.addEventListener('focusout', function (e) {
            if (!dropdown.contains(e.relatedTarget)) closeDropdown(dropdown);
          });
          // Hover already opens the panel on these devices, so a click on a voice that has its own
          // page must NAVIGATE instead of just toggling the <details>. data-url is emitted in Liquid
          // only when the voice has a real URL (not blank, not '#'). Cmd/Ctrl-click preserves the
          // open-in-new-tab intent.
          // Questo ramo esiste solo in modalità "hover" (l'intero blocco lo è): il click naviga
          // perché l'hover ha già aperto il pannello. In modalità "click" il primo click apre il
          // pannello e la pagina si raggiunge dal "Vedi tutto".
          var navSummary = dropdown.querySelector('summary');
          if (navSummary && navSummary.dataset.url) {
            navSummary.addEventListener('click', function (e) {
              e.preventDefault();
              var url = navSummary.dataset.url;
              if (e.metaKey || e.ctrlKey) {
                window.open(url, '_blank', 'noopener,noreferrer');
              } else {
                window.location.href = url;
              }
            });
          }
        });
      }

      state.onDocClick = function (e) {
        dropdowns.forEach(function (dropdown) {
          if (!dropdown.contains(e.target)) {
            dropdown.open = false;
            dropdown.classList.remove('is-hover-open');
            syncExpanded(dropdown);
          }
        });
        syncScrim();
      };
      state.onDocKeydown = function (e) {
        if (e.key !== 'Escape') return;
        dropdowns.forEach(function (dropdown) {
          // If focus is inside the panel being closed, return it to the summary so it is
          // never lost on a hidden element (same focus-return contract as search/mobile).
          var hadFocus = dropdown.contains(document.activeElement);
          dropdown.open = false;
          dropdown.classList.remove('is-hover-open');
          syncExpanded(dropdown);
          if (hadFocus) {
            var summary = dropdown.querySelector('summary');
            if (summary) {
              // summary.focus() below fires a synchronous focusin that bubbles to this
              // <details>; without the flag, the hoverCapable 'focusin' listener above would
              // call openDropdown(dropdown) in the same tick and undo the close we just did.
              // Clear the flag on the next frame so a genuine later Tab/focus still opens it.
              state.suppressFocusReopen = true;
              cancelAnimationFrame(state.focusReopenRaf);
              summary.focus();
              state.focusReopenRaf = requestAnimationFrame(function () {
                state.suppressFocusReopen = false;
              });
            }
          }
        });
        syncScrim();
      };
      document.addEventListener('click', state.onDocClick);
      document.addEventListener('keydown', state.onDocKeydown);

      // Tiene --mega-scrim-top allineata mentre lo scrim è visibile: la pila header cambia altezza
      // quando la announcement bar (non sticky) esce dallo schermo e quando l'header passa allo
      // stato .is-scrolled. Come <sticky-atc> in product.js: ogni evento pianifica UN solo
      // requestAnimationFrame, così uno scroll a raffica non produce una misura per evento.
      state.onScrimReflow = function () {
        if (state.scrimReflowRaf) return;
        state.scrimReflowRaf = requestAnimationFrame(function () {
          state.scrimReflowRaf = null;
          var scrim = document.getElementById('MegaScrim');
          if (!scrim || scrim.hidden) return;
          scrim.style.setProperty('--mega-scrim-top', MegaMenu.measureHeaderBottom(root) + 'px');
        });
      };
      window.addEventListener('scroll', state.onScrimReflow, { passive: true });
      window.addEventListener('resize', state.onScrimReflow, { passive: true });

      // Tiene visibile il pannello mentre il merchant modifica il block nel Theme Editor.
      state.onBlockSelect = function (e) {
        var dropdown = e.target.closest && e.target.closest('.header__dropdown');
        if (!dropdown) return;
        dropdown.open = true;
        dropdown.classList.add('is-hover-open');
        syncExpanded(dropdown);
        syncScrim();
        // If the selected block is a mega_menu_feature, show its card in the rail too — selecting
        // it in the Theme Editor's block list should preview the same card hovering its trigger
        // link would show, not silently leave the default card in view.
        var selectedId = e.detail && e.detail.blockId;
        var card = selectedId && dropdown.querySelector('[data-mega-feature-id="' + selectedId + '"]');
        if (card) {
          Array.from(card.parentNode.children).forEach(function (c) { c.hidden = c !== card; });
        }
      };
      state.onBlockDeselect = function (e) {
        var dropdown = e.target.closest && e.target.closest('.header__dropdown');
        if (!dropdown) return;
        dropdown.open = false;
        dropdown.classList.remove('is-hover-open');
        syncExpanded(dropdown);
        syncScrim();
      };
      root.addEventListener('shopify:block:select', state.onBlockSelect);
      root.addEventListener('shopify:block:deselect', state.onBlockDeselect);
    },

    // Bordo inferiore REALE della pila header, misurato: è da lì che parte lo scrim, che deve
    // oscurare la pagina e non l'header. Nessun z-index può ottenere lo stesso risultato — lo
    // scrim è figlio del wrapper di sezione che DIPINGE lo sfondo dell'header (fix sticky del
    // 2026-07-24), e lo sfondo di un genitore sta sempre sotto i suoi figli. Il numero non si può
    // dedurre dal setting header_height: ignora la announcement bar e i due stati dello sticky
    // (stessa lezione della barra acquisto sticky della PDP → misura, non dedurre). Si parte dal
    // wrapper dell'header e si tiene il bordo più basso fra le sezioni sticky del gruppo header
    // attualmente agganciate in cima (rect.top <= 1), così una barra "after-scroll" ancora fuori
    // schermo non conta.
    measureHeaderBottom: function (root) {
      var bottom = 0;
      var own = root && root.closest ? root.closest('.shopify-section') : null;
      if (own) bottom = own.getBoundingClientRect().bottom;
      document.querySelectorAll('.shopify-section-group-header-group').forEach(function (section) {
        if (getComputedStyle(section).position !== 'sticky') return;
        var rect = section.getBoundingClientRect();
        if (rect.top > 1) return;
        if (rect.bottom > bottom) bottom = rect.bottom;
      });
      return Math.max(0, Math.round(bottom));
    },

    // Mostra/nasconde lo scrim quando almeno un dropdown è aperto/hover-open. Pattern
    // render→reflow→classe come la search modal. Il div può non esistere (setting off) → guardia.
    syncScrim: function (root) {
      var scrim = document.getElementById('MegaScrim');
      if (!scrim) return;
      var state = root._mega || {};
      var anyOpen = (state.dropdowns || []).some(function (d) {
        return d.open || d.classList.contains('is-hover-open');
      });
      if (anyOpen) {
        clearTimeout(state.scrimHideTimer);
        scrim.style.setProperty('--mega-scrim-top', MegaMenu.measureHeaderBottom(root) + 'px');
        scrim.hidden = false;
        scrim.getBoundingClientRect();
        state.scrimRaf = requestAnimationFrame(function () {
          if (!scrim.hidden) scrim.classList.add('is-visible');
        });
      } else {
        cancelAnimationFrame(state.scrimRaf);
        scrim.classList.remove('is-visible');
        state.scrimHideTimer = setTimeout(function () { scrim.hidden = true; }, 300);
      }
    },

    destroy: function (root) {
      var state = root && root._mega;
      if (!state) return;
      document.removeEventListener('click', state.onDocClick);
      document.removeEventListener('keydown', state.onDocKeydown);
      window.removeEventListener('scroll', state.onScrimReflow);
      window.removeEventListener('resize', state.onScrimReflow);
      root.removeEventListener('shopify:block:select', state.onBlockSelect);
      root.removeEventListener('shopify:block:deselect', state.onBlockDeselect);
      clearTimeout(state.scrimHideTimer);
      cancelAnimationFrame(state.scrimRaf);
      cancelAnimationFrame(state.scrimReflowRaf);
      cancelAnimationFrame(state.focusReopenRaf);
      delete root._mega;
      delete root.dataset.megaInit;
    }
  };

  var MobileNav = {
    init: function (root) {
      var drawer = document.getElementById('MobileMenu');
      if (!drawer) return;
      // Captured on the root (the <store-header> instance) so destroy() can tear down exactly
      // this drawer instance later, even if by then document.getElementById('MobileMenu') would
      // resolve to a different node (see destroy() below) — same root-scoped-state pattern as
      // MegaMenu, which stores its state on the root it was given. Recorded even when the guard
      // below short-circuits the rest of init, so a root whose drawer happens to already be
      // initialized still gets a correct reference for its own eventual teardown.
      if (root) root._navDrawer = drawer;
      if (drawer.dataset.navInit === 'true') return;
      drawer.dataset.navInit = 'true';
      var state = {};
      drawer._nav = state;
      var panel = drawer.querySelector('.mobile-nav__panel');
      var rootScreen = drawer.querySelector('[data-nav-root]');
      var screens = drawer.querySelector('.mobile-nav__screens');

      var activeScreen = function () { return drawer.querySelector('.mobile-nav__screen--sub.is-active'); };

      // .mobile-nav__screens is an overflow:hidden box and the incoming screen starts at
      // translateX(100%), i.e. laid out one full panel width to its right. A plain focus() on
      // anything inside it while it is still translated makes the browser scroll the box to
      // reveal that element (359px on a 390px viewport) — and that scroll STAYS after the
      // transform lands on 0, parking the active screen off-canvas and leaving the inert sibling
      // in view (nothing clickable, wrong category). Hence: every focus() inside this box is
      // preventScroll, and the box is re-zeroed on every screen change so a future distracted
      // focus() cannot reopen the defect. Focus itself still moves — a11y is not traded away.
      var resetScroll = function () { if (screens) screens.scrollLeft = 0; };

      var openScreen = function (id, trigger) {
        var screen = document.getElementById(id);
        if (!screen) return;
        state.trigger = trigger;
        screen.classList.add('is-active');
        screen.removeAttribute('inert');
        if (rootScreen) rootScreen.setAttribute('inert', '');
        drawer.classList.add('is-sub');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        var back = screen.querySelector('[data-nav-back]');
        if (back) back.focus({ preventScroll: true });
        resetScroll();
      };
      var closeScreen = function () {
        var screen = activeScreen();
        if (!screen) return;
        screen.classList.remove('is-active');
        screen.setAttribute('inert', '');
        if (rootScreen) rootScreen.removeAttribute('inert');
        drawer.classList.remove('is-sub');
        if (state.trigger) {
          state.trigger.setAttribute('aria-expanded', 'false');
          state.trigger.focus({ preventScroll: true });
          state.trigger = null;
        }
        resetScroll();
      };
      state.closeScreen = closeScreen;

      drawer.querySelectorAll('[data-open-screen]').forEach(function (btn) {
        btn.addEventListener('click', function () { openScreen(btn.getAttribute('data-open-screen'), btn); });
      });
      drawer.querySelectorAll('[data-nav-back]').forEach(function (btn) {
        btn.addEventListener('click', closeScreen);
      });

      // Focus trap: cicla solo sugli elementi focusabili della schermata ATTIVA più la testata.
      // La schermata inattiva è già `inert`, quindi non entra nella query.
      var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, summary, [tabindex]:not([tabindex="-1"])';
      state.onKeydown = function (e) {
        if (drawer.hidden) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          if (activeScreen()) { closeScreen(); } else { MobileNav.close(root); }
          return;
        }
        if (e.key !== 'Tab') return;
        var items = Array.from(panel.querySelectorAll(FOCUSABLE)).filter(function (el) {
          return el.offsetParent !== null && !el.closest('[inert]');
        });
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      };
      document.addEventListener('keydown', state.onKeydown);
    },

    // Spostato da StoreHeader.toggleMobile senza cambi di comportamento: render → reflow → classe,
    // scroll lock sulla pagina e ritorno del focus a chi ha aperto il drawer.
    open: function (root, opener) {
      var drawer = document.getElementById('MobileMenu');
      if (!drawer) return;
      var state = drawer._nav || {};
      var toggle = root.querySelector('[data-menu-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      state.opener = opener || document.activeElement;
      clearTimeout(state.hideTimer);
      // Reset to the root screen synchronously: close() defers this same reset to inside the
      // 360ms hide timer (see below), which clearTimeout above just cancelled. Without this,
      // closing on a category screen and reopening within that window left the drawer showing
      // the stale sub-screen instead of the root one.
      if (state.closeScreen) state.closeScreen();
      drawer.hidden = false;
      drawer.getBoundingClientRect();
      state.openRaf = requestAnimationFrame(function () {
        if (!drawer.hidden) drawer.classList.add('is-open');
      });
      // `button[...]`, not `[data-menu-close]`: the FIRST node carrying that attribute in DOM order
      // is the overlay <div> (a plain div is not focusable, so focus() on it was a no-op and the
      // focus stayed outside the drawer — the first Tab stops then landed on the page BEHIND the
      // overlay). The real close control is the <button> in the drawer head.
      var close = drawer.querySelector('button[data-menu-close]');
      // preventScroll: the panel is still at translateX(-100%) at this point, so a scroll-into-view
      // here would fight the opening transition (same class of bug as the screens box below).
      if (close) close.focus({ preventScroll: true });
    },
    close: function (root) {
      var drawer = document.getElementById('MobileMenu');
      if (!drawer) return;
      var state = drawer._nav || {};
      var toggle = root.querySelector('[data-menu-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      cancelAnimationFrame(state.openRaf);
      drawer.classList.remove('is-open');
      state.hideTimer = setTimeout(function () {
        drawer.hidden = true;
        if (state.closeScreen) state.closeScreen();
      }, 360);
      if (state.opener) state.opener.focus();
    },
    destroy: function (root) {
      // Re-resolving via getElementById here (like init used to) is exactly the bug: if the Theme
      // Editor has already inserted a replacement #MobileMenu by the time this runs, that lookup
      // can return the NEW drawer instead of the one this root actually owns, tearing down (and
      // orphaning) the wrong instance's listeners. Use the reference init captured on this root.
      var drawer = root && root._navDrawer;
      var state = drawer && drawer._nav;
      if (!state) return;
      document.removeEventListener('keydown', state.onKeydown);
      clearTimeout(state.hideTimer);
      cancelAnimationFrame(state.openRaf);
      delete drawer._nav;
      delete drawer.dataset.navInit;
      delete root._navDrawer;
    }
  };
  window.HendyMobileNav = MobileNav;

  window.HendyMegaMenu = MegaMenu;
})();
